<template>
  <div class="summary-metric">
    <Typography variant="body-1">{{ title }}</Typography>
    <Typography variant="h-2" :class="{ 'error--text': error, 'success--text': success }">{{
      value
    }}</Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
export default {
  name: "SummaryMetric",
  components: {
    Typography,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.summary-metric {
  display: flex;
  flex-direction: column;
  text-align: left;
  border-radius: 8px;
  background: var(--Surface-Light-Dark, #f6f5f6);
  padding: 1rem 1.5rem;
  height: 100%;
}
.error {
  color: var(--error);
}
</style>
